<template>
  <div class="content" v-bind:class="{hidden: Index > 0}" v-bind:data-target="Index">
    <BlackAndWhite
      v-if="IsBlackAndWhite == true"
    ></BlackAndWhite>
    <Images
      v-else
      :Source="Source"
    >
    </Images>
  </div>
</template>

<script>
import BlackAndWhite from "./BlackAndWhite";
import Images from "./Images";
export default {
  data() {
    return {
      last: false
    };
  },
  props: {
    IsBlackAndWhite: Boolean,
    Position: Number,
    Next: Number,
    Before: Number,
    Index: Number,
    Last: Boolean,
    Source: String
  },
  components: {
    BlackAndWhite,
    Images
  },
  watch: {
    Last: function(value) {
      this.last = value;
    }
  }
};
</script>
